import React from 'react';
import { Spin } from 'antd';
import { Route, useHistory, useRouteMatch } from 'react-router';
import { useQueryClient } from 'react-query';
import useFacility from '../../queries/useFacility';
import { roomQueryKeys } from '../../queries/queryKeys';
import styles from './Breadcrumbs.module.scss';

const Breadcrumbs = () => {
  const queryClient = useQueryClient();
  const {
    params: { facilityId, roomId, facilityTab },
  } = useRouteMatch(
    '/Offices/facilities/:facilityId?/:facilityTab?/:roomId?'
  ) || {
    params: {},
  };
  const history = useHistory();

  const { data: facility, isFetching: isFacilityLoading } =
    useFacility(facilityId);

  const room = queryClient.getQueryData(roomQueryKeys(roomId));

  return (
    <Spin spinning={isFacilityLoading || false}>
      <div className={styles.breadcrumbs}>
        <Route path="/Offices/facilities/:facilityId">
          <span
            className={styles.breadcrumb}
            onClick={() => history.push('/Offices/facilities')}
          >
            Офисы
          </span>
          <span
            className={styles.breadcrumb}
            onClick={() =>
              history.push(`/Offices/facilities/${facilityId}/rooms`)
            }
          >
            {facility?.name && `/ ${facility?.name}`}
          </span>
        </Route>
        <Route path="/Offices/facilities/:facilityId/:facilityTab/:roomId">
          <span
            className={styles.breadcrumb}
            onClick={() =>
              history.push(
                `/Offices/facilities/${facilityId}/${facilityTab}/${roomId}/about`
              )
            }
          >
            {room?.name && `/ ${room.name}`}
          </span>
        </Route>
      </div>
    </Spin>
  );
};

export default Breadcrumbs;
